import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4ZM4 6V9H20V6H4ZM20 10.75H16V18H20V10.75ZM14.25 10.75H9.75V18H14.25V10.75ZM8 10.75H4V18H8V10.75Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTable = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgTable;
